import { PropsWithChildren, useMemo } from "react";
import { ApolloProvider } from "@apollo/client";
import { ApolloProvider as ApolloHooksProvider } from "@apollo/client";
import { History } from "history";
import { Router } from "react-router";
import { ToastProvider } from "react-toast-notifications";
import getApolloClient from "../apollo";
import { SupportedLanguages } from "../generated/graphql";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { SELECTED_LANGUAGE_KEY } from "../utils/i18n/utils";
import Toast from "./Common/Toast";
import CompatibilityCheck from "./CompatibilityCheck";
import ErrorBoundary from "./ErrorBoundary";

export type AppType = "guest" | "client";

type AppScaffoldProps = { history: History; app?: AppType };

export const AppScaffold = ({
  history,
  app = "client",
  children,
}: PropsWithChildren<AppScaffoldProps>) => {
  const { getValue } = useLocalStorage<SupportedLanguages>({
    key: SELECTED_LANGUAGE_KEY,
  });

  const language = getValue();

  const ApolloClient = useMemo(
    () => getApolloClient(app, language),
    [app, language],
  );

  return (
    <ToastProvider placement="bottom-right" autoDismiss components={{ Toast }}>
      <ApolloProvider client={ApolloClient}>
        <ApolloHooksProvider client={ApolloClient}>
          <CompatibilityCheck app={app}>
            <Router history={history}>
              <ErrorBoundary>{children}</ErrorBoundary>
            </Router>
          </CompatibilityCheck>
        </ApolloHooksProvider>
      </ApolloProvider>
    </ToastProvider>
  );
};
